import { gql } from "@apollo/client";

import { DIPLOMA_FIELDS } from "../queries/diplomas";

export const CREATE_DIPLOMA = gql`
  mutation CreateDiploma($input: UpdateDiplomaInput!) {
    createCertDiploma(input: $input) {
      ...DiplomaFields
    }
  }
  ${DIPLOMA_FIELDS}
`;

export const UPDATE_DIPLOMA = gql`
  mutation UpdateDiploma($id: ID!, $input: UpdateDiplomaInput!) {
    updateCertDiploma(id: $id, input: $input) {
      ...DiplomaFields
    }
  }
  ${DIPLOMA_FIELDS}
`;

export const DELETE_DIPLOMA = gql`
  mutation DeleteDiploma($id: ID!) {
    deleteCertDiploma(id: $id) {
      id
    }
  }
`;
